import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import '../stylesheets/tailwind.css';
import { ThemeProvider } from '../single-page/components/ui/theme-provider.jsx';
import { initI18n } from '../single-page/lib/i18n.js';
import installBfcacheReload from '../single-page/lib/bfcacheReload.js';
import Public from '../public/Public.jsx';

installBfcacheReload();

const root_div = document.getElementById('root')
const root = ReactDOM.createRoot(root_div);
const props = JSON.parse(root_div.dataset['parameters']);
const i18n = initI18n(props.locale);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <ThemeProvider defaultTheme="light" storageKey="rdmapps-public-theme" ignoreStored>
        <Public flash={props.flash} />
      </ThemeProvider>
    </I18nextProvider>
  </React.StrictMode>
);
